// Earning is parked while the points module is hidden from the UI: awards still write their ledger
// row (who, why, which idea/praise, which month) so the history survives, but they are worth
// nothing. Restoring the programme is a matter of putting these back to 1.
export const POINTS_PER_IDEA_APPROVED = 0;
export const POINTS_PER_PRAISE = 0;
export const POINTS_MONTHLY_CAP = 20;

export const POINTS_REASONS = {
  IDEA_APPROVED: 'idea_approved',
  PRAISE: 'praise',
  MARKET_PURCHASE: 'market_purchase',
  ORDER_REJECTED: 'order_rejected',
} as const;

export type PointsReason = (typeof POINTS_REASONS)[keyof typeof POINTS_REASONS];
